// extracted by mini-css-extract-plugin
export default {"about":"About_about__E2SU4","stats":"About_stats__U8JN9","about__main":"About_about__main__fCdt9","about__text":"About_about__text__z1xMl","about__image":"About_about__image__koWQH"};